import type { FieldValue, DefaultFieldValues } from '@kizen/api';

export const isActualCloseDateValue = (
  fv: FieldValue
): fv is DefaultFieldValues['actual_close_date'] => {
  return fv.name === 'actual_close_date';
};

export const isBirthdayValue = (
  fv: FieldValue
): fv is DefaultFieldValues['birthday'] => {
  return fv.name === 'birthday';
};

export const isBusinessPhoneValue = (
  fv: FieldValue
): fv is DefaultFieldValues['business_phone'] => {
  return fv.name === 'business_phone';
};

export const isCreatedValue = (
  fv: FieldValue
): fv is DefaultFieldValues['created'] => {
  return fv.name === 'created';
};

export const isEmailValue = (
  fv: FieldValue
): fv is DefaultFieldValues['email'] => {
  return fv.name === 'email';
};

export const isEmailStatusValue = (
  fv: FieldValue
): fv is DefaultFieldValues['email_status'] => {
  return fv.name === 'email_status';
};

export const isEstimatedCloseDateValue = (
  fv: FieldValue
): fv is DefaultFieldValues['estimated_close_date'] => {
  return fv.name === 'estimated_close_date';
};

export const isEntityValueValue = (
  fv: FieldValue
): fv is DefaultFieldValues['entity_value'] => {
  return fv.name === 'entity_value';
};

export const isFirstNameValue = (
  fv: FieldValue
): fv is DefaultFieldValues['first_name'] => {
  return fv.name === 'first_name';
};

export const isHomePhoneValue = (
  fv: FieldValue
): fv is DefaultFieldValues['home_phone'] => {
  return fv.name === 'home_phone';
};

export const isLastNameValue = (
  fv: FieldValue
): fv is DefaultFieldValues['last_name'] => {
  return fv.name === 'last_name';
};

export const isMobilePhoneValue = (
  fv: FieldValue
): fv is DefaultFieldValues['mobile_phone'] => {
  return fv.name === 'mobile_phone';
};

export const isNameValue = (
  fv: FieldValue
): fv is DefaultFieldValues['name'] => {
  return fv.name === 'name';
};

export const isOwnerValue = (
  fv: FieldValue
): fv is DefaultFieldValues['owner'] => {
  return fv.name === 'owner';
};

export const isPercentageChanceToCloseValue = (
  fv: FieldValue
): fv is DefaultFieldValues['percentage_chance_to_close'] => {
  return fv.name === 'percentage_chance_to_close';
};

export const isStageValue = (
  fv: FieldValue
): fv is DefaultFieldValues['stage'] => {
  return fv.name === 'stage';
};

export const isTagsValue = (
  fv: FieldValue
): fv is DefaultFieldValues['tags'] => {
  return fv.name === 'tags';
};

export const isTimezoneValue = (
  fv: FieldValue
): fv is DefaultFieldValues['timezone'] => {
  return fv.name === 'timezone';
};

export const isTitlesValue = (
  fv: FieldValue
): fv is DefaultFieldValues['titles'] => {
  return fv.name === 'titles';
};

export const isUpdatedValue = (
  fv: FieldValue
): fv is DefaultFieldValues['updated'] => {
  return fv.name === 'updated';
};
